"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHex = exports.pickGlyphColor = exports.getStepStateColors = void 0;
const HslColor_1 = require("@jsonjoy.com/ui/lib/styles/color/HslColor");
const RgbColor_1 = require("@jsonjoy.com/ui/lib/styles/color/RgbColor");
/** State governs color only, line thickness is configured separately. */
const getStepStateColors = (styles, state) => {
    switch (state) {
        case 'pending': {
            const line = styles.grey.toString();
            return { line, bg: styles.grey.g(0.04), glyph: line };
        }
        case 'active': {
            const line = styles.g(0.05);
            return { line, bg: styles.grey.g(0.04), glyph: line };
        }
        case 'done': {
            const line = styles.positive.toString();
            return { line, bg: line, glyph: '#ffffff' };
        }
        case 'warning': {
            const line = styles.warning.toString();
            return { line, bg: styles.warning.g(0.04), glyph: line };
        }
        case 'error': {
            const line = styles.negative.toString();
            return { line, bg: styles.negative.g(0.04), glyph: line };
        }
        case 'optional': {
            const line = styles.grey.g(0.35);
            return { line, bg: styles.grey.g(0.02), glyph: line };
        }
    }
};
exports.getStepStateColors = getStepStateColors;
const GLYPH_BLACK = new HslColor_1.HslColor(0, 0, 0.05);
const GLYPH_WHITE = new HslColor_1.HslColor(0, 0, 0.97);
/** Pick a glyph color with enough WCAG contrast against the flattened bullet background. */
const pickGlyphColor = (styles, bgCss, fallback) => {
    const bg = HslColor_1.HslColor.from(bgCss);
    if (!bg)
        return fallback;
    const flattened = bg.flatten(styles.bg.fg);
    const choice = flattened.bestContrast(GLYPH_BLACK, GLYPH_WHITE);
    if (flattened.contrast(choice) < 4)
        return fallback;
    return (0, exports.toHex)(choice.toString());
};
exports.pickGlyphColor = pickGlyphColor;
/** Format any CSS color as `#RRGGBB` or `#RRGGBBAA`. */
const toHex = (css) => {
    const rgb = RgbColor_1.RgbColor.fromString(css);
    if (rgb)
        return rgb.hex();
    const hsl = HslColor_1.HslColor.from(css);
    return hsl ? hsl.toRgb().hex() : css;
};
exports.toHex = toHex;
